<template>
  <span class="opc-v-loader">
    <i v-if="loading" class="zm-icon-loading" />
    <span v-else>{{ value }}</span>
  </span>
</template>
  
<script>
export default {
  props: {
    loading: Boolean,
    value: String,
  },
};
</script>
      
<style lang="scss" scoped>
.opc-v-loader {
}
</style>